import React from 'react';
import PropTypes from 'prop-types';
import calendarIcon from '../../images/calendar_icon_red.svg';
import clubIcon from '../../images/club_icon_red.svg';
import affiliationIcon from '../../images/coach_member_icon.svg';
import replayerTvIcon from '../../images/replayer_tv_icon.svg';
import shopIcon from '../../images/negozio.svg';

const ACTION_ICONS = {
  affiliations: affiliationIcon,
  booking: calendarIcon,
  showcase: clubIcon,
  shop: shopIcon,
  store: shopIcon,
  subscriptions: replayerTvIcon
};

const PublicPartnerSkyworkActionRibbon = ({actions, ariaLabel, onAction, sequence}) => {
  if (!actions.length) {
    return null;
  }

  return (
    <section className="replayer-club-page__action-ribbon" aria-label={ariaLabel}>
      <div className="replayer-club-page__action-sequence" aria-hidden="true">
        {sequence.map((item, index) => (
          <React.Fragment key={item}>
            {index > 0 && <span>›</span>}
            <strong>{item}</strong>
          </React.Fragment>
        ))}
      </div>
      <div className="replayer-club-page__action-list">
        {actions.map(action => (
          <button
            type="button"
            className={`replayer-club-page__action replayer-club-page__action--${action.kind}`}
            key={action.id}
            aria-expanded={action.expanded === undefined ? undefined : action.expanded}
            onClick={() => onAction(action)}
          >
            <span className="replayer-club-page__action-icon">
              <img src={ACTION_ICONS[action.kind] || replayerTvIcon} alt="" aria-hidden="true"/>
            </span>
            <strong>{action.label}</strong>
            <span className="replayer-club-page__action-arrow" aria-hidden="true">→</span>
          </button>
        ))}
      </div>
    </section>
  );
};

PublicPartnerSkyworkActionRibbon.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    expanded: PropTypes.bool,
    id: PropTypes.string.isRequired,
    kind: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),
  ariaLabel: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  sequence: PropTypes.arrayOf(PropTypes.string).isRequired
};

PublicPartnerSkyworkActionRibbon.defaultProps = {
  actions: []
};

export default PublicPartnerSkyworkActionRibbon;
